var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7734 14.9287H14.5703V17H12.5059V14.9287H8.24023V13.459L12.6221 7.00586H14.5703V13.2881H15.7734V14.9287ZM12.5059 13.2881V11.5928C12.5059 11.3102 12.5173 10.9001 12.54 10.3623C12.5628 9.82454 12.5811 9.51237 12.5947 9.42578H12.54C12.3714 9.79948 12.1686 10.1641 11.9316 10.5195L10.0996 13.2881H12.5059Z",
    fill: "parent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourIcon);
export default __webpack_public_path__ + "static/media/FourIcon.18766721a8ac536fa8b794db79b76b60.svg";
export { ForwardRef as ReactComponent };